import { Button } from '@boltenergy-be/design-system'
import classNames from 'classnames'
import styles from './SideCardAction.module.scss'
import { SideCardActionProps } from './types'

const SideCardAction = ({ className, ...props }: SideCardActionProps) => {
  return <Button className={classNames(styles.action, className)} representation="link" {...props} />
}

export default SideCardAction
